import { StudioEventTemplate, EventTemplateFromEventCreate, StudioEventTemplateResponse } from '@goldcast/api/backend';

export function transformServerTemplates(
  templates: Array<StudioEventTemplate | EventTemplateFromEventCreate | StudioEventTemplateResponse>
): StudioEventTemplate | EventTemplateFromEventCreate | {} {
  const transformedTemplates: StudioEventTemplate | EventTemplateFromEventCreate | {} = {};

  templates.forEach(template => {
    transformedTemplates[template.id] = template;
  });

  return transformedTemplates;
}
